import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

function GenerateConfig () {
  return [
    {
      numid: 0,
      id: 'sun',
      name: i18n.t('tipos.semanas.sun'),
      shortname: i18n.t('tipos.semanas.short.sun')
    },
    {
      numid: 1,
      id: 'mon',
      name: i18n.t('tipos.semanas.mon'),
      shortname: i18n.t('tipos.semanas.short.mon')
    },
    {
      numid: 2,
      id: 'tue',
      name: i18n.t('tipos.semanas.tue'),
      shortname: i18n.t('tipos.semanas.short.tue')
    },
    {
      numid: 3,
      id: 'wed',
      name: i18n.t('tipos.semanas.wed'),
      shortname: i18n.t('tipos.semanas.short.wed')
    },
    {
      numid: 4,
      id: 'thu',
      name: i18n.t('tipos.semanas.thu'),
      shortname: i18n.t('tipos.semanas.short.thu')
    },
    {
      numid: 5,
      id: 'fri',
      name: i18n.t('tipos.semanas.fri'),
      shortname: i18n.t('tipos.semanas.short.fri')
    },
    {
      numid: 6,
      id: 'sat',
      name: i18n.t('tipos.semanas.sat'),
      shortname: i18n.t('tipos.semanas.short.sat')
    }
  ]
}

export function WEEK_DAYS (state) {
  return configHelper.getConfig(state, 'WEEK_DAYS', GenerateConfig)
}
